// extracted by mini-css-extract-plugin
export default {"ljiRed":"#ee2346","rowWarning":"TriggerRuleGrid_rowWarning__p-Hcu"};